import { render, staticRenderFns } from "./arrowStepsCenter.vue?vue&type=template&id=35d5aae1"
import script from "./arrowStepsCenter.vue?vue&type=script&lang=js"
export * from "./arrowStepsCenter.vue?vue&type=script&lang=js"
import style0 from "./arrowStepsCenter.vue?vue&type=style&index=0&id=35d5aae1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports